import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../lib/auth";

export function AdminRoute() {
  const { user, loading, isAdmin } = useAuth();

  if (loading) return <div className="full-screen-loading">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}
